import React from "react";
import { Slide } from "react-awesome-reveal";
import skillsLight from "../media/skills-light.svg";
import skillsDark from "../media/skills-dark.svg";
import MongoDB from "../media/mongodb-icon.svg";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCss3Alt,
  faDocker,
  faHtml5,
  faJs,
  faReact,
  faNodeJs,
} from "@fortawesome/free-brands-svg-icons";
import { faBorderNone } from "@fortawesome/free-solid-svg-icons";

const Skills = ({ darkMode }) => {
  return (
    <div data-theme={darkMode ? "dark" : "light"}>
      <br />
      <Slide>
        <Container>
          <Row>
            <Col lg={4} xs={8}>
              <h1 className="display-3 skill-h">
                I can work <p className="with">with</p>{" "}
              </h1>
              <img
                src={darkMode ? skillsDark : skillsLight}
                alt="skills"
                className="skills-img img-fluid animated"
                height="187px"
                width="207px"
              />
            </Col>
            <Col lg={2} xs={4}>
              <br />
              <Card className="nbcard">
                <a
                  href="https://html.spec.whatwg.org/multipage/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="HTML5"
                  >
                    <FontAwesomeIcon
                      className="skill"
                      size="2x"
                      icon={faHtml5}
                    />
                  </Button>
                </a>
                <a
                  href="https://www.w3.org/Style/CSS/Overview.en.html"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="CSS3"
                  >
                    <FontAwesomeIcon
                      className="skill"
                      size="2x"
                      icon={faCss3Alt}
                    />
                  </Button>
                </a>
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="JS"
                  >
                    <FontAwesomeIcon className="skill" size="2x" icon={faJs} />
                  </Button>
                </a>
                <a
                  href="https://reactjs.org/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="React"
                  >
                    <FontAwesomeIcon
                      className="skill"
                      size="2x"
                      icon={faReact}
                    />
                  </Button>
                </a>
                {/* <Button variant={darkMode ? "outline-light" : "outline-dark"} className="skills-btn" aria-label="Docker">
                                    <FontAwesomeIcon className="skill" size='2x' icon={faDocker} />
                                </Button> */}
                <a
                  href="https://nodejs.org/en/about/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="Node"
                  >
                    <FontAwesomeIcon
                      className="skill"
                      size="2x"
                      icon={faNodeJs}
                    />
                  </Button>
                </a>
                <a
                  href="https://www.mongodb.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <Button
                    variant={darkMode ? "outline-light" : "outline-dark"}
                    className="skills-btn"
                    aria-label="MongoDB"
                    style={{ padding: "0px" }}
                  >
                    {/* <p align="center" className="skill-txt">C</p> */}
                    <img src={MongoDB} alt="" style={{ width: "40px" }} />
                  </Button>
                </a>
              </Card>
            </Col>
            <Col lg={6} xs={12}>
              <br />
              <Card className="skill-nbcard">
                <Card.Body>
                  <Card.Title>Programming Languages</Card.Title>
                  <Card.Text>Typescript, Javascript</Card.Text>
                </Card.Body>
              </Card>
              <Card className="skill-nbcard">
                <Card.Body>
                  <Card.Title>Technologies</Card.Title>
                  <Card.Text>
                    React, NextJS, Redux, Redux-Saga, Scss/Sass, Pusher
                    (WebSocket), Clerk, Stripe, Shadcn, Unit-Testing(Jest +
                    React Testing Library), HTML, CSS, Eslint, NodeJs,
                    ExpressJs, MongoDb, Github, Material-UI, Bootstrap,
                    GraphQL(basic).
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <br />
          <hr></hr>
        </Container>
      </Slide>
    </div>
  );
};

export default Skills;
